import React from "react";

import {
	BlogContentWrapper,
	ItemWrapper,
	TableOfContentsWrapper,
} from "./style";

import {
	Text,
	Link,
	Grid,
	Col,
	Separator,
	CloudinaryImage,
	Button,
} from "@website-builder/ui/shared/elements";
import {
	handleCTAClick,
	scrollToElement,
} from "@website-builder/utilities-index";
import BlogVideo from "../../BlogVideo";

const TableOfContents = ({ contentLinks = [], isHeaderSticky = false }) => {
	return (
		<TableOfContentsWrapper isHeaderSticky={isHeaderSticky}>
			<Text variant="label_L" className="table-of-contents-heading">
				IN THIS ARTICLE
			</Text>
			{contentLinks.map((tableItem) => {
				return (
					<Link
						onClick={() => scrollToElement(tableItem?.link, 150)}
						target="_self"
						key={tableItem?.link}
					>
						<Text variant="paragraph_L" className="table-of-contents-item">
							{tableItem?.text}
						</Text>
					</Link>
				);
			})}
			<Separator />
		</TableOfContentsWrapper>
	);
};

const BlogContentWR = ({
	contents = [],
	tableOfContents = [],
	isHeaderSticky = false,
}) => {
	const buildBlogContent = () => {
		return contents.map((item, index) => {
			switch (item?.component) {
				case "blogHeading":
					return (
						<ItemWrapper key={index} id={item?.hashLink}>
							<Text variant="headline_4" tag="h2">
								{item?.text}
							</Text>
						</ItemWrapper>
					);
				case "blogHeadingRichtext":
					return (
						<ItemWrapper key={index} id={item?.hashLink}>
							<Text
								variant="headline_4"
								tag="div"
								dangerouslySetInnerHTML={{ __html: item?.text }}
								className="rich-text-wrapper"
							></Text>
						</ItemWrapper>
					);
				case "textWR":
				case "BlogContent":
					return (
						<ItemWrapper
							key={index}
							className={
								item?.component === "BlogContent" ? "grouped-text-wr" : null
							}
						>
							<Text variant="paragraph_L" tag="div">
								<div
									dangerouslySetInnerHTML={{ __html: item?.text }}
									className="rich-text-wrapper"
								></div>
							</Text>
						</ItemWrapper>
					);
				case "leanerImage":
					return (
						<ItemWrapper key={index} className="blog-image-wrapper">
							<CloudinaryImage
								className="blog-image"
								url={item?.image}
								quality="auto"
								lazyload
								fetchFormat="auto"
								alt={item?.alt}
							/>
						</ItemWrapper>
					);
				case "BlogImage":
					return (
						<ItemWrapper key={index} className="blog-image-wrapper">
							<CloudinaryImage
								className="blog-image blog-image-desktop"
								url={item?.image}
								quality="auto"
								lazyload
								fetchFormat="auto"
								alt={item?.alt}
							/>
							<CloudinaryImage
								className="blog-image blog-image-mobile"
								url={item?.mobileImage}
								quality="auto"
								lazyload
								fetchFormat="auto"
								alt={item?.mobileAlt}
							/>
							<Text variant="paragraph_S" className="subtitle">
								{item?.subtitle}
							</Text>
						</ItemWrapper>
					);
				case "CTAButton":
					return (
						<ItemWrapper key={index}>
							<Button
								buttonText={item?.text}
								type="primary"
								primaryColorButton={true}
								onClick={(e) =>
									handleCTAClick(
										item,
										{
											redirect_to: item?.link?.link,
											click_text: item?.text,
										},
										{},
										e,
									)
								}
							></Button>
						</ItemWrapper>
					);
				case "BlogVideo":
					return (
						<ItemWrapper key={index} className="blog-video">
							<BlogVideo url={item?.url} subtitle={item?.subtitle} />
						</ItemWrapper>
					);

				default:
					return null;
			}
		});
	};

	return (
		<BlogContentWrapper>
			<Grid hMargin={[0, 0]}>
				{tableOfContents.length ? (
					<Col span={3} mdSpan={6}>
						<TableOfContents
							contentLinks={tableOfContents}
							isHeaderSticky={isHeaderSticky}
						/>
					</Col>
				) : null}
				<Col span={9} mdSpan={6}>
					<div className="blog-content">{buildBlogContent()}</div>
				</Col>
			</Grid>
		</BlogContentWrapper>
	);
};

export default BlogContentWR;
